(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pristine-top-ten"] && !Shopify.designMode) return;
  try {
    
(() => {
  const load = async root => {
    if (root.dataset.loaded) return;
    root.dataset.loaded = '1';
    try {
      const response = await fetch('https://admin-v3.pristinestreaming.com/api/public/top-ten', {credentials:'omit', signal:AbortSignal.timeout(10000)});
      if (!response.ok) throw new Error('Chart unavailable');
      const chart = await response.json();
      if (!Array.isArray(chart.entries) || chart.entries.length !== 10) throw new Error('Incomplete chart');
      const list = document.createDocumentFragment();
      const element = (tag, className, text) => { const node=document.createElement(tag); node.className=className; if(text!==undefined) node.textContent=text; return node; };
      chart.entries.forEach((entry,index) => {
        if (entry.rank !== index+1 || !/^\/products\/pa[a-z]{1,4}\d{3,}$/.test(entry.url) || typeof entry.title !== 'string' || new URL(entry.cover).protocol !== 'https:') throw new Error('Invalid entry');
        const item=element('li','pa-top-ten__item');
        const rank=element('span','pa-top-ten__rank',String(entry.rank)); rank.setAttribute('aria-hidden','true');
        const cover=element('a','pa-top-ten__cover');cover.href=entry.url;cover.tabIndex=-1;cover.setAttribute('aria-hidden','true');
        const img=document.createElement('img');img.src=entry.cover;img.alt='';img.width=80;img.height=80;img.loading='lazy';cover.append(img);
        const copy=element('div','pa-top-ten__copy');const title=element('h3','pa-top-ten__title');const link=element('a','',entry.title);link.href=entry.url;title.append(link);
        const button=element('a','pa-top-ten__button',root.dataset.buttonLabel);button.href=entry.url;button.setAttribute('aria-label',root.dataset.buttonLabel+': '+entry.title);copy.append(title,button);item.append(rank,cover,copy);list.append(item);
      });
      const date=value=>{if(!/^\d{4}-\d{2}-\d{2}$/.test(value))throw new Error('Invalid date');return new Date(value+'T12:00:00Z').toLocaleDateString(document.documentElement.lang||'en-GB',{day:'numeric',month:'short',year:'numeric',timeZone:'Europe/Paris'});};
      root.querySelector('[data-chart-dates]').textContent=date(chart.from)+' – '+date(chart.to);
      root.querySelector('[data-chart-list]').replaceChildren(list);
      root.hidden=false;
    } catch (_) { delete root.dataset.loaded; }
  };
  const start=()=>document.querySelectorAll('[data-pa-top-ten]').forEach(load);
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',start);else start();
  document.addEventListener('shopify:section:load',start);
})();

  } catch(e) { console.error(e); }
})();
})();
